import { searchAccounts } from '../api/eae'

export function searchSchoolOptions(vm, options) {
    const keyword = options.keyword
    const country = options.country
    const setKeyword = options.setKeyword
    const setAccounts = options.setAccounts
    const missingCountryMessage = options.missingCountryMessage || 'Please select your country first before searching for schools'

    if (vm._schoolSearchTimer) {
        clearTimeout(vm._schoolSearchTimer)
    }
    const requestId = (vm._schoolSearchRequestId || 0) + 1
    vm._schoolSearchRequestId = requestId

    if (!country) {
        vm.$message.error({
            message: missingCountryMessage,
            duration: 5000
        })
        vm.loading = false
        return
    }

    if (!keyword) {
        setAccounts([])
        vm.loading = false
        return
    }

    setKeyword(keyword)
    vm.loading = true

    vm._schoolSearchTimer = setTimeout(() => {
        searchAccounts(keyword, country).then((res) => {
            if (requestId !== vm._schoolSearchRequestId) {
                return
            }
            if (res.data && res.data.status === 'error') {
                vm.$message.error({
                    message: res.data.msg || 'Search failed',
                    duration: 5000
                })
                setAccounts([])
            } else {
                setAccounts(Array.isArray(res.data) ? res.data : [])
            }
        }).catch(() => {
            if (requestId !== vm._schoolSearchRequestId) {
                return
            }
            vm.$message.error({
                message: 'Search failed. Please try again.',
                duration: 5000
            })
            setAccounts([])
        }).finally(() => {
            if (requestId === vm._schoolSearchRequestId) {
                vm.loading = false
            }
        })
    }, 300)
}
